import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const EditIcon = ({ label = 'Edit', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path transform="rotate(45 139.978 161.08)" style="fill:#f4c223" d="M99.9 75.9h80.2v170.24H99.9z"/><path d="M108.2 251.1a5.1 5.1 0 0 1-3.5-1.5l-56.8-56.7a5.1 5.1 0 0 1 0-7.1L168.3 65.4a5.1 5.1 0 0 1 7.1 0l56.7 56.8a4.8 4.8 0 0 1 0 7L111.7 249.6a5.1 5.1 0 0 1-3.5 1.5zm-49.7-61.8 49.7 49.7 113.3-113.3L171.8 76z" style="fill:#1d1d1b"/><path d="M228.6 130.7a5.1 5.1 0 0 1-3.6-1.5l-56.7-56.7a5.1 5.1 0 0 1-1.5-3.5 5.3 5.3 0 0 1 1.5-3.6l24-23.9a34.4 34.4 0 0 1 48.6 0l15.2 15.1a34.5 34.5 0 0 1 0 48.7l-24 23.9a5 5 0 0 1-3.5 1.5zM178.9 69l49.7 49.6L249 98.2a24.4 24.4 0 0 0 0-34.5l-15.2-15.2a24.4 24.4 0 0 0-34.4 0zM30.7 271.9a5.1 5.1 0 0 1-3.6-1.5 5.3 5.3 0 0 1-1.3-4.8L46.6 188a5.3 5.3 0 0 1 3.6-3.5 5 5 0 0 1 4.8 1.3l56.7 56.7a5 5 0 0 1-2.2 8.4L32 271.7zM54.1 199l-16.4 60.8 60.8-16.3zm94.7-76.2a5 5 0 0 1-3.5-8.5l18.9-18.9a5 5 0 0 1 7.1 0 5 5 0 0 1 0 7l-18.9 18.9a5.1 5.1 0 0 1-3.6 1.5zm-21.4 21.4a5 5 0 0 1-3.5-8.5l3.7-3.8a5.1 5.1 0 0 1 7.1 0 5 5 0 0 1 0 7.1l-3.8 3.8a5 5 0 0 1-3.5 1.4z" style="fill:#1d1d1b"/><path d="M30.7 271.9a5.1 5.1 0 0 1-3.6-1.5 5.1 5.1 0 0 1 0-7.1l18.3-18.2a5 5 0 0 1 7.1 0 5 5 0 0 1 0 7l-18.3 18.3a4.9 4.9 0 0 1-3.5 1.5zM204.5 66.5a4.8 4.8 0 0 1-2.8-.8 5 5 0 0 1-1.4-6.9c3.1-4.7 13.1-11.7 28.3-4.8a4.9 4.9 0 0 1 2.5 6.6 5 5 0 0 1-6.6 2.5c-11.4-5.2-15.8 1.1-15.8 1.2a5 5 0 0 1-4.2 2.2z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

EditIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { EditIcon }
